import { useState, useEffect, useContext, FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { listarContratoModelo } from '../../services/contratosModelos'
import { contratosModelosListaResposta } from '../../interfaces/contratosModelos'
import ModalContratosModelos from '../ModalContratosModelos'
import Permissoes from '../../middleware/Permissoes'
import FiltrosDefault from '../FiltrosDefault'
import avatarDefault from '../../assets/img/avatarDefault.png'
import DivSituacao from '../DivSituacao'
import LoagindBarra from '../LoadingBarra'
import Notificacoes from '../Notificacoes'
import erroImg from '../../assets/img/erroFechar.png'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import ModulosContratados from '../../middleware/SistemasContratados'

function ContratosModelos () {

    const { atualizarInformacoes, modal, modalExibir } = useContext(ModalEstadoContext)

    const navigate = useNavigate()
    const location = useLocation()

    const { pathname } = location

    const [contratos, setContratos] = useState<contratosModelosListaResposta[]>([])
    const [contratoSelecionado, setContratoSelecionado] = useState<contratosModelosListaResposta>()
    const [termo, setTermo] = useState('')
    const [situacao, setSituacao] = useState('')
    const [processando, setProcessando] = useState(false)
    const [processandoPesquisa, setProcessandoPesquisa] = useState(false)
    const [nenhumResultado, setNenhumResultado] = useState(false)
    const [erro, setErro] = useState(false)

    const exibirModalNovoModelo = () => {
        
        return modalExibir('contratosModelos')
    }


    const exibirModalContratosModelos = (contrato: contratosModelosListaResposta, idModelo: string) => {

        navigate(`${pathname}?idModelo=${idModelo}`)

        modalExibir('contratosModelos')

        return setContratoSelecionado(contrato)

    }

    const buscarContratos = async (e: FormEvent) => {

        e.preventDefault()
        setNenhumResultado(false)
        setProcessandoPesquisa(true)

        const params = {
            termo,
            situacao
        }

        try {

            const resposta = await listarContratoModelo(params)

            if (resposta.data.length === 0) {
                setContratos(resposta.data)
                setProcessandoPesquisa(false)
                return setNenhumResultado(true)
            }

            if (resposta.status === 200) {
                setContratos(resposta.data)

                return setProcessandoPesquisa(false)
            }
            
        } catch (error) {
            setProcessandoPesquisa(false)
            setErro(true)

            return setTimeout(() => {
                setErro(false)
            }, 2000)
        }
    }

    useEffect(() => {

        if(modal.nome === '') setContratoSelecionado(undefined)

        return

    }, [modal])

    useEffect(() => {

        const buscarContratos = async () => {

            setNenhumResultado(false)
            setProcessando(true)

            const params = {
                    termo: '',
                    situacao: ''
                }

            try {

                const resposta = await listarContratoModelo(params)

                if (resposta.data.length === 0) {
                    setContratos(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if (resposta.status === 200) {

                    setContratos(resposta.data)

                    return setProcessando(false)
                }
                
            } catch (error) {
                
            }
        }

        buscarContratos ()

    }, [atualizarInformacoes])

    return (
        <ModulosContratados modulo={["Documentos"]}>
            <Permissoes permissoes={['master', 'doc_modelo_contrato']}>
                <div id='paginaContainer'>
                    {modal.nome === 'contratosModelos' && <ModalContratosModelos modeloContrato={contratoSelecionado}/>}
                    {processando && <LoagindBarra />}
                    {nenhumResultado && <NenhumResultadoEncontrado />}
                    {erro && <Notificacoes icone={erroImg} texto='Falha ao Processar a Solicitação!' cor='erro'/>}
                    <FiltrosDefault termo={termo} situacao={situacao} placeholder='Pesquise pelo título do contrato' tipo={'Modelo'} onChangeTermo={(e) => setTermo(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarContratos} acaoBtn={exibirModalNovoModelo} listaSituacao={[{nome: 'Todas', valor: ''}, {nome: 'Ativos', valor: 'Ativo'}, {nome: 'Inativos', valor: 'Inativo'}]} genero='masculino' isLoading={processandoPesquisa}/>

                    <section id='fundoContainerPagina'>
                        <table id='tabelaListaContainer'>
                            <thead>
                                <tr>
                                    <th id='ladoEsquerdoContent' align='left'>Título do Contrato</th>
                                    <th id='solicitacaoDocumento' align='left'>Criado por</th>
                                    <th align='center'>Última Alteração</th>
                                    <th align='center'>Situação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contratos.map((contrato) => (
                                    <tr key={contrato.id} onClick={() => exibirModalContratosModelos(contrato, contrato.id)}>
                                        <td id='primeiraColuna'>{contrato.descricao}</td>
                                        <td align='center' className='usuarioResponsavelContent'>
                                            <img className='usuarioResponsavel' src={contrato.usuario.avatar ? contrato.usuario.avatar : avatarDefault} alt='' />
                                                {contrato.usuario.nome}
                                        </td>
                                        <td align='center'>
                                            {new Date(contrato.alterado).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', 
                                                hour: '2-digit', 
                                                minute: '2-digit',
                                                day: '2-digit', 
                                                month: '2-digit', 
                                                year: 'numeric' 
                                                }).replace(',', ' às ')}
                                        </td>
                                        <td align='center' id='ladoDireitoContent'>
                                            <DivSituacao texto={`${contrato.situacao}`} cor={contrato.situacao.toLowerCase().replace(/\s+/g, '')}/>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section>
                </div>
            </Permissoes>
        </ModulosContratados>
    )
}

export default ContratosModelos
